export const ORDER_HISTORY_RECEIVED = "ORDER_HISTORY_RECEIVED";
export const PATIENT_ORDER_HISTORY_RECEIVED = "PATIENT_ORDER_HISTORY_RECEIVED";
export const ORDER_DETAIL_RECEIVED = "ORDER_DETAIL_RECEIVED";
export const SALES_ORDER_RECEIVED = "SALES_ORDER_RECEIVED";
